module.exports = __webpack_public_path__ + "assets/img/hotel-img-grey.2cd3e5b6.png";